import { globalPolyfills } from './core';

globalPolyfills().then(() => import(/* webpackChunkName: "productBuilder" */'./core/productBuilder'));
